import React from 'react';
import './styles/Card.css';

export const Card = ({
  children,
  className = '',
  interactive = false,
  hover = true,
  padded = true,
  ...props
}) => {
  const classes = `card ${padded ? 'card-padded' : ''} ${interactive ? 'card-interactive' : ''} ${hover ? 'card-hover' : ''} ${className}`;
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export const CardHeader = ({ children, className = '', ...props }) => (
  <div className={`card-header ${className}`} {...props}>{children}</div>
);

export const CardBody = ({ children, className = '', ...props }) => (
  <div className={`card-body ${className}`} {...props}>{children}</div>
);

export const CardFooter = ({ children, className = '', ...props }) => (
  <div className={`card-footer ${className}`} {...props}>{children}</div>
);

export const CardTitle = ({ children, className = '', ...props }) => (
  <h3 className={`card-title ${className}`} {...props}>{children}</h3>
);

export const CardSubtitle = ({ children, className = '', ...props }) => (
  <p className={`card-subtitle ${className}`} {...props}>{children}</p>
);

export default Card;
